<script>
export default {
  name: "ServiceRowAlert",
  props: {
    alerts: {
      type: [Function, Array],
      default: () => [],
    },
    summary: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: "is-top",
    },
  },
};
</script>

<template>
  <span>
    <b-tooltip
      v-for="(alert, index) in alerts"
      :key="index"
      multilined
      :position="position"
      :label="alert.description"
      :class="'ml-1 service-row-badge service-row-badge-' + alert.type"
    >
      <b-tag
        rounded
        :style="{ color: alert.color, backgroundColor: alert.background }"
      >
        <strong>
          {{ index !== 0 && summary ? alert.tag : alert.label }}
        </strong>
      </b-tag>
    </b-tooltip>
  </span>
</template>

<style scoped>
.service-row-badge {
  margin-left: 1px;
}

::v-deep .service-row-badge .tooltip-content {
  width: 300px !important;
}

.service-row-badge strong {
  color: inherit;
  font-size: 10px;
}

.service-row-badge-viper .tag,
.service-row-badge-viper .tooltip-content {
  border: 2px solid #ba1117 !important;
  font-weight: bold;
  padding: 0.5em 1em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
